import PropTypes from 'prop-types';
import React from 'react';
import {
	Dialog,
	DialogTitle,
	DialogContent,
	DialogActions,
	useMediaQuery
} from '@mui/material';
import PrimaryButton from '../Button/primary-button.js';

const FeedbackDialog = ({
	open,
	onClose,
	handleAction,
	title,
	feedback,
	onChangeFeedback,
	errorMessage,
	buttonText,
	loading = false,
	isRemarks = false
}) => {
	const isMobile = useMediaQuery('(max-width:600px)');
	const handleButtonClick = () => {
		handleAction();
	};

	return (
		<Dialog
			open={open}
			slotProps={{ paper: { style: { width: '421px', borderRadius: '12px' } } }}
		>
			<DialogTitle sx={{ fontSize: '18px' }}>{title}</DialogTitle>
			<DialogContent sx={{ paddingBottom: '0px' }}>
				<div style={{ fontSize: '14px' }}>
					{isRemarks ? 'Type Remarks' : 'Type feedback'}
				</div>
				<textarea
					value={feedback}
					onChange={onChangeFeedback}
					style={{
						width: '100%',
						height: '133px',
						borderRadius: '8px',
						border: '1px solid',
						padding: '10px',
						resize: 'none',
						'&:focus': { borderColor: '#B7D423' }
					}}
					placeholder='ex- Please check spelling mistakes'
				></textarea>
				<span>{errorMessage}</span>
			</DialogContent>
			<DialogActions
				sx={{
					display: 'flex',
					justifyContent: 'center',
					gap: '10px',
					padding: '30px 0'
				}}
			>
				<PrimaryButton
					value='Cancel'
					width={isMobile ? '116' : '166px'}
					height='40px'
					borderRadius='8px'
					onClick={onClose}
					backgroundColor='transparent'
					border='2px solid #b6d423'
					color='#b6d423'
					fontSize='16px'
				/>
				<PrimaryButton
					value={buttonText}
					backgroundColor='#B7D423'
					padding='0'
					width={isMobile ? '117px' : '167px'}
					height='40px'
					borderRadius='10px'
					onClick={handleButtonClick}
					disabled={loading}
				/>
			</DialogActions>
		</Dialog>
	);
};

export default FeedbackDialog;

FeedbackDialog.propTypes = {
	open: PropTypes.any,
	onClose: PropTypes.any,
	handleAction: PropTypes.any,
	title: PropTypes.any,
	feedback: PropTypes.any,
	onChangeFeedback: PropTypes.any,
	errorMessage: PropTypes.any,
	buttonText: PropTypes.any,
	loading: PropTypes.any,
	isRemarks: PropTypes.any
};
